import { Delete } from 'ui/icons';
import { GhostButton } from 'ui/button';

import { useModalContext } from '../contexts/ModalContext';
import { List } from '../types';

type DeleteListCellProps = {
  list: List;
};

export const DeleteListCell = ({ list }: DeleteListCellProps) => {
  const { showDeletionModal } = useModalContext();
  return (
    <GhostButton data-test={`${list.name}-deleteButton`} onClick={() => showDeletionModal(list)}>
      <Delete height={20} />
    </GhostButton>
  );
};
